var map = {
	"./en": 346,
	"./en.json": 346,
	"./sk": 347,
	"./sk.json": 347,
	"./sk.json.orig": 607
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 606;


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n ^\.\/.*$
// module id = 606
// module chunks = 0